
export default {
  'pricing.title': 'Opciones de Membresía Exclusivas',
  'pricing.subtitle': 'Elija el nivel de membresía perfecto para satisfacer sus deseos',
  'pricing.basic': 'Básico',
  'pricing.popular': 'Popular',
  'pricing.elite': 'Élite',
  'pricing.no_ads': 'Sin anuncios',
  'pricing.access_teaser': 'Acceso a contenido privado de avance',
  'pricing.basic_messaging': 'Acceso básico a mensajería',
  'pricing.view_contacts': 'Ver detalles de contacto de escorts',
  'pricing.get_started': 'Comenzar',
  'pricing.all_teaser': 'Todos los beneficios de Teaser',
  'pricing.client_verification': 'Verificación de cliente incluida',
  'pricing.full_access': 'Acceso completo a todas las fotos y videos',
  'pricing.leave_reviews': 'Dejar reseñas después de encuentros',
  'pricing.priority_support': 'Soporte prioritario',
  'pricing.subscribe_now': 'Suscribirse Ahora',
  'pricing.all_regular': 'Todos los beneficios de Regular',
  'pricing.vip_badge': 'Insignia VIP en perfil y mensajes',
  'pricing.early_access': 'Acceso anticipado a nuevas escorts',
  'pricing.vip_escorts': 'Acceso a escorts solo para VIP',
  'pricing.discounted_rates': 'Tarifas con descuento para contenido premium',
  'pricing.go_vip': 'Hacerse VIP',
  'pricing.faq_title': 'Preguntas Frecuentes',
  'pricing.faq.how_subscriptions': '¿Cómo funcionan las suscripciones?',
  'pricing.faq.how_subscriptions_answer': 'Nuestras suscripciones se facturan mensualmente y proporcionan acceso por niveles a funciones y contenido. Puede actualizar, degradar o cancelar en cualquier momento.',
  'pricing.faq.payment_secure': '¿Es segura mi información de pago?',
  'pricing.faq.payment_secure_answer': 'Sí, utilizamos encriptación estándar de la industria para todas las transacciones. Nunca almacenamos sus datos completos de pago en nuestros servidores.',
  'pricing.faq.refund': '¿Puedo obtener un reembolso?',
  'pricing.faq.refund_answer': 'Ofrecemos reembolsos prorrateados dentro de los primeros 3 días de suscripción si no está satisfecho con nuestros servicios.',
  'pricing.faq.verification': '¿Cuál es el proceso de verificación?',
  'pricing.faq.verification_answer': 'Nuestro proceso de verificación asegura que tanto las escorts como los clientes sean personas reales. Es rápido, seguro y protege la privacidad de todos.',
  'pricing.choose_plan': 'Elija Su Plan',
  
  // New translations for subscription plan names and prices
  'subscription.teaser.title': 'Pink Teaser',
  'subscription.teaser.price': '4,99€/mes',
  'subscription.regular.title': 'Pink Regular',
  'subscription.regular.price': '19,99€/mes',
  'subscription.vip.title': 'Pink VIP',
  'subscription.vip.price': '100€/mes',
  
  // Additional translations for UI elements
  'pricing.privacy_title': 'Privacidad Mejorada',
  'pricing.privacy_description': 'Características de privacidad mejoradas para su total tranquilidad.',
  'pricing.content_title': 'Contenido Exclusivo',
  'pricing.content_description': 'Acceda a contenido exclusivo y servicios premium no disponibles para usuarios gratuitos.',
  'pricing.support_title': 'Soporte Prioritario',
  'pricing.support_description': 'Soporte prioritario para todas sus necesidades.',
  'pricing.learn_more': 'Saber más',
  'pricing.see_examples': 'Ver ejemplos',
  'pricing.contact_support': 'Contactar soporte',
  'pricing.detailed_comparison': 'Comparación detallada de características',
  'pricing.feature': 'Característica',
  'pricing.description': 'Descripción',
  
  // Feature descriptions
  'pricing.no_ads_description': 'Navegación sin anuncios intrusivos',
  'pricing.access_teaser_description': 'Vista previa del contenido privado de escorts',
  'pricing.basic_messaging_description': 'Capacidad para enviar mensajes básicos',
  'pricing.view_contacts_description': 'Ver información de contacto de escorts',
  'pricing.client_verification_description': 'Insignia de verificación para mayor confianza',
  'pricing.full_access_description': 'Acceso completo a galerías privadas',
  'pricing.leave_reviews_description': 'Capacidad para dejar reseñas después de citas',
  'pricing.priority_support_description': 'Asistencia prioritaria cuando lo necesite',
  'pricing.vip_badge_description': 'Insignia VIP exclusiva en su perfil',
  'pricing.early_access_description': 'Acceso anticipado a nuevos perfiles',
  'pricing.vip_escorts_description': 'Acceso a escorts exclusivas para miembros VIP',
  'pricing.discounted_rates_description': 'Tarifas preferenciales en servicios premium'
};
